export const SELECT_PRODUCT_MRTA = 'SELECT_PRODUCT_MRTA'

export const selectProductMRTA = (productCode) => ({
  type: SELECT_PRODUCT_MRTA,
  payload: productCode,
})

export const SELECT_BASIC_PLAN = 'SELECT_BASIC_PLAN'
export const selectBasicPlan = (product) => ({
  type: SELECT_BASIC_PLAN,
  payload: product,
})

export const MRTA_UPDATE_LOAN_AMOUNT = 'MRTA_UPDATE_LOAN_AMOUNT'
export const updateLoanAmount = (loanAmount) => ({
  type: MRTA_UPDATE_LOAN_AMOUNT,
  payload: {
    value: loanAmount,
    errors: [],
  },
})

export const MRTA_EDIT_LOAN_AMOUNT = 'MRTA_EDIT_LOAN_AMOUNT'
export const editLoanAmount = (loanAmount) => ({
  type: MRTA_EDIT_LOAN_AMOUNT,
  payload: {
    value: loanAmount,
    errors: [],
  },
})

export const MRTA_UPDATE_LOAN_PERIOD = 'MRTA_UPDATE_LOAN_PERIOD'
export const updateLoanPeriod = (loanPeriod) => ({
  type: MRTA_UPDATE_LOAN_PERIOD,
  payload: {
    value: loanPeriod,
    errors: [],
  },
})

export const MRTA_EDIT_LOAN_PERIOD = 'MRAT_EDIT_LOAN_PERIOD'
export const editLoanPeriod = (loanPeriod) => ({
  type: MRTA_EDIT_LOAN_PERIOD,
  payload: {
    value: loanPeriod,
    errors: [],
  },
})

export const MRTA_UPDATE_COVERAGE_PERIOD = 'MRTA_UPDATE_COVERAGE_PERIOD'
export const updateCoveragePeriod = (coveragePeriod) => ({
  type: MRTA_UPDATE_COVERAGE_PERIOD,
  payload: coveragePeriod,
})

export const MRTA_EDIT_COVERAGE_PERIOD = 'MRTA_EDIT_COVERAGE_PERIOD'
export const editCoveragePeriod = (coveragePeriod) => ({
  type: MRTA_EDIT_COVERAGE_PERIOD,
  payload: coveragePeriod,
})

export const MRTA_EDIT_INTEREST_RATE = 'MRTA_EDIT_INTEREST_RATE'
export const editInterestRate = (interestRate) => ({
  type: MRTA_EDIT_INTEREST_RATE,
  payload: interestRate,
})

export const MRTA_EDIT_SUMASSURED_CONTRACT = 'MRTA_EDIT_SUMASSURED_CONTRACT'
export const editMRTASumAssuredContract = (sumAssuredContract) => ({
  type: MRTA_EDIT_SUMASSURED_CONTRACT,
  payload: sumAssuredContract,
})

export const MRTA_EDIT_PAYMENT_SELECTED_MRTA = 'MRTA_EDIT_PAYMENT_SELECTED_MRTA'
export const editPaymentSelectedMRTA = (paymentSelectedMRTA) => ({
  type: MRTA_EDIT_PAYMENT_SELECTED_MRTA,
  payload: paymentSelectedMRTA,
})

export const MRTA_UPDATE_ERROR_STATUS = 'MRTA_UPDATE_ERROR_STATUS'
export const updateErrorStatus = (value) => ({
  type: MRTA_UPDATE_ERROR_STATUS,
  payload: value,
})

export const MRTA_UPDATE_SUM_ASSURED_IN_LOAN = 'MRTA_UPDATE_SUM_ASSURED_IN_LOAN'
export const updateMRTASumAssuredInLoan = (sumAssured) => ({
  type: MRTA_UPDATE_SUM_ASSURED_IN_LOAN,
  payload: sumAssured,
})

export const MRTA_UPDATE_CODE_IN_SELECTED_DISPLAY_PRODUCT = 'MRTA_UPDATE_CODE_IN_SELECTED_DISPLAY_PRODUCT'
export const updateCodeInSelectedDisplayProduct = (code) => ({
  type: MRTA_UPDATE_CODE_IN_SELECTED_DISPLAY_PRODUCT,
  payload: code,
})

export const MRTA_UPDATE_COVERAGE_PERIOD_IN_SELECTED_DISPLAY_PRODUCT =
  'MRTA_UPDATE_COVERAGE_PERIOD_IN_SELECTED_DISPLAY_PRODUCT'
export const updateCoveragePeriodInSelectedDisplayProduct = (coveragePeriod) => ({
  type: MRTA_UPDATE_COVERAGE_PERIOD_IN_SELECTED_DISPLAY_PRODUCT,
  payload: coveragePeriod,
})

export const UPDATE_VALIDATE_COVERAGE_PERIOD_ERRORS = 'UPDATE_VALIDATE_COVERAGE_PERIOD_ERRORS'
export const updateValidateCoveragePeriodErros = (coveragePeriod) => ({
  type: UPDATE_VALIDATE_COVERAGE_PERIOD_ERRORS,
  payload: coveragePeriod,
})

export const UPDATE_VALIDATE_INTEREST_RATE_ERRORS = 'UPDATE_VALIDATE_INTEREST_RATE_ERRORS'
export const updateValidateInterestRateErros = (interestRate) => ({
  type: UPDATE_VALIDATE_INTEREST_RATE_ERRORS,
  payload: interestRate,
})
